import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { endExerciseApi, getMyProfile, getParticipantActiveExercise, getParticularExercise, startExerciseApi, submitInjectResponse } from "../../../APIConfig/CtfConfig";

const initialState = {
  loading: false,
  profileData: null,
  activeExercises: [],
  exerciseDetails: null,
  error: null,
};


// Async thunk for fetching participant active exercise
export const fetchParticipantActiveExercise = createAsyncThunk(
  'participantProfile/fetchActiveExercise',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getParticipantActiveExercise();
      return response.data;
    } catch (error) {
      //   return rejectWithValue(error?.response?.data || 'Failed to fetch profile');
    }
  }
);
export const fetchParticularExercise = createAsyncThunk(
  'participantProfile/fetchParticularExercise',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getParticularExercise(id);
      return response.data;
    } catch (error) {
      //   return rejectWithValue(error?.response?.data || 'Failed to fetch profile');
    }
  }
);
export const startExercise = createAsyncThunk(
  'participantProfile/startExercise',
  async (id, { rejectWithValue }) => {
    try {
      const response = await startExerciseApi(id);
      return response.data;
    } catch (error) {
      //   return rejectWithValue(error?.response?.data || 'Failed to fetch profile');
    }
  }
);
export const endExercise = createAsyncThunk(
  'participantProfile/endExercise',
  async (id, { rejectWithValue }) => {
    try {
      const response = await endExerciseApi(id);
      return response.data;
    } catch (error) {
      //   return rejectWithValue(error?.response?.data || 'Failed to fetch profile');
    }
  }
);
export const submitInject = createAsyncThunk(
  'participantProfile/submitInject',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await submitInjectResponse(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data || 'Failed to submit inject');
    }
  }
);
// Async thunk for fetching participant profile
export const fetchParticipantProfile = createAsyncThunk(
  'participantProfile/fetchProfile',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getMyProfile();
      return response.data;
    } catch (error) {
      //   return rejectWithValue(error?.response?.data || 'Failed to fetch profile');
    }
  }
);

const participantProfileSlice = createSlice({
  name: 'participantProfile',
  initialState,
  reducers: {
    clearProfile: (state) => {
      state.profileData = null;
      state.activeExercises = [];
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchParticipantProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchParticipantProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.profileData = action.payload;
        state.error = null;
      })
      .addCase(fetchParticipantProfile.rejected, (state, action) => {
        state.loading = false;
        state.profileData = null;
        state.error = action.payload || 'Something went wrong';
      });
    builder
      .addCase(startExercise.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(startExercise.fulfilled, (state, action) => {
        state.loading = false; 
        state.error = null;
      })
      .addCase(startExercise.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.payload || 'Something went wrong';
      });
    builder
      .addCase(endExercise.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(endExercise.fulfilled, (state, action) => {
        state.loading = false; 
        state.error = null;
      })
      .addCase(endExercise.rejected, (state, action) => {
        state.loading = false; 
        state.error = action.payload || 'Something went wrong';
      });
    builder
      .addCase(fetchParticipantActiveExercise.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchParticipantActiveExercise.fulfilled, (state, action) => {
        state.loading = false;
        state.activeExercises = action.payload;
        state.error = null;
      })
      .addCase(fetchParticipantActiveExercise.rejected, (state, action) => {
        state.loading = false;
        state.activeExercises = [];
        state.error = action.payload || 'Something went wrong';
      });
    builder
      .addCase(fetchParticularExercise.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchParticularExercise.fulfilled, (state, action) => {
        state.loading = false;
        state.exerciseDetails = action.payload;
        state.error = null;
      })
      .addCase(fetchParticularExercise.rejected, (state, action) => {
        state.loading = false;
        state.exerciseDetails = null;
        state.error = action.payload || 'Something went wrong';
      });
  },
});

export const { clearProfile } = participantProfileSlice.actions;
export default participantProfileSlice.reducer;
